import { Component, OnInit } from '@angular/core';
import { FswService } from '@services/fsw.service';
import { AuthService } from '@services/auth.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-list-awp',
  templateUrl: './list-awp.component.html',
  styleUrls: ['./list-awp.component.scss']
})
export class ListAwpComponent implements OnInit {

  fileName= 'Awareness_Programs_PageWise_Excel.xlsx';

  p: number = 1;
  p1: number = 1;
  itemsPerPage : number = 10;
  stateCode !: any;
  fromDate !: any;
  endDate !: any;
  seachText !: any;
  selectedvehicleNo !:any;
  vehicles!: any;
  isReadMode = true;
  role:any;
  programTitle:any;
  vehicleNo:any;
  stateName:any;
  awpId:any;
  trainerName:any;
  isDeleteMode = false;
  AwpsRecordData!: any[];
  state_name!: any;
  adminRemark:any;
  selectCount:number=10;

  constructor(private fswService: FswService,private toastr: ToastrService, private authService: AuthService, private spinnerService: NgxSpinnerService, private route: ActivatedRoute, private router: Router, private location:Location) { }

  ngOnInit(): void {
    this.role = this.authService.getRole();
    this.route.params.subscribe(params => {
      this.stateCode = params['stateCode']; // (+) converts string 'id' to a number
      //this.state_name = params['stateName'];
    });
    if(this.stateCode)
    {
      this.getAwpListByStateCode(this.stateCode);
    }
    else
    {
      this.getAwpList();
    }

    setTimeout(() => {
      this.spinnerService.hide();
    }, 1000);
  }
  Awps: any[] = [{Awp_title:"test title", Awp_desc:"Test Description", no_of_trainees:"2"}]

  userName: any;
  userRole: any;

  getAwpList() {
debugger
this.spinnerService.show();
    this.userName = this.authService.getUserName();
    this.userRole = this.authService.getRole();
    console.log(this.userRole)
    if(this.userName!='admin') {
    this.fswService.getAwsListByUser(this.userName)
      .subscribe(res => {
      debugger
         this.Awps = res;
         this.AwpsRecordData  = res;
         this.spinnerService.hide();
      });
    }
    else{
      this.fswService.getAwsList()
      .subscribe(res => {
      debugger
      this.Awps = res;
      this.AwpsRecordData  = res;
         this.spinnerService.hide();
      });

    }
  }
 
  deleteawp(x: any) {
    debugger
     var delBtn = confirm(" Do you want to delete the awareness programme?");
     if (delBtn == true) {
       debugger
      this.spinnerService.show();
      console.log(x);
      //  this.trainingId = x.trainingId;
      this.programTitle=x.programTitle;
      //  this.trainingTitle=x.trainingTitle;
       this.trainerName=x.trainerName;
      // this.userId = x.userId;
       this.vehicleNo = x.vehicleNo;
       this.seachText=x.stateName;
       this.awpId=x.awpId;
       this.stateName=x.stateName;
            // this.chasisNo=x.chasisNo;

      // this.emailId = x.emailId;
      // this.mobileNo = x.mobileNo;
       this.isDeleteMode = true;
      this.isReadMode = false;
      // this.isUpdateMode = false;
      
      this.spinnerService.hide();
      }
  }

  getAwpListByStateCode(stateCode) {
    this.spinnerService.show();
   
    this.userName = this.authService.getUserName();

    this.fswService.getawpListByStateVehicleNo(stateCode)
      .subscribe(res => {
         this.vehicles = res;
        console.log('vehicleNo',this.vehicles)
      });

    this.fswService.getawpListByState(stateCode)
      .subscribe(res => {
      debugger
      this.Awps = res;
      this.AwpsRecordData  = res;
      this.state_name = res[0].stateName;
      
         this.spinnerService.hide();        
      });
  }
  ondeleteAwpSubmit()
  {
    let awpId=this.awpId;
    let  data =
    {
      "awpId":this.awpId, 
      "adminRemark":this.adminRemark,
      
    }
   
    this.fswService.deleteAwarenessProgram(data)
    .subscribe(
      response => {
        this.spinnerService.hide();
        this.toastr.success('AwareNess Programme  Deleted Successfully!');
        this.isReadMode = true;
        this.isDeleteMode = false;
        if(this.stateCode)
        {
          
          this.getAwpListByStateCode(this.stateCode);
        }
        else
        {
          this.getAwpList();
        }
       
      }
    );
  }
  search() {
    debugger
    console.log(this.seachText);
    this.p=1;
    this.AwpsRecordData = this.Awps;
    let filteredData=this.Awps;

    if(this.selectedvehicleNo != undefined && this.selectedvehicleNo != ""){   
      filteredData = filteredData.filter(m => (m.vehicleNo == this.selectedvehicleNo))
    }

    if(this.seachText != undefined && this.seachText != ""){
      filteredData = filteredData.filter(m => (m.programTitle.indexOf(this.seachText)>-1));
         
      }
      // if(this.fromDate != undefined && this.endDate != undefined)
      // {
      //   debugger
      //  //var d1 = new Date(this.fromDate);
      //  //var d2 = new Date(this.endDate);
      //  /* var startDate = this.fromDate.split("-");
      //  var d1 = startDate[2] + '/' + startDate[1] + '/' + startDate[0];
      //  var toDate = this.endDate.split("-");
      //  var d2 = toDate[2] + '/' + toDate[1] + '/' + toDate[0]; */
      //  var datePipe = new DatePipe("en-US");
        
      //   filteredData = filteredData.filter(m =>{
      //     var testingDate = new Date(datePipe.transform(new Date(m.programDate), 'yyyy-MM-dd'));
      //       var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
      //       var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
      //       if((testingDate>=d1) && (testingDate<=d2))
      //       {
      //         return m;
      //       }
          
      //   })
      // }
      if(this.fromDate != undefined && this.endDate != undefined && this.fromDate!=""&&this.endDate!="")
      {
        debugger
      // var d1 = new Date(this.fromDate);
       //var d2 = new Date(this.endDate);
       /* var startDate = this.fromDate.split("-");
       var d1 = startDate[2] + '/' + startDate[1] + '/' + startDate[0];
       var toDate = this.endDate.split("-");
       var d2 = toDate[2] + '/' + toDate[1] + '/' + toDate[0]; */
       if(this.seachText!=undefined && this.seachText!="")
       {
       var datePipe = new DatePipe("en-US");
        
        filteredData = filteredData.filter(m =>{
          var testingDate = new Date(datePipe.transform(new Date(m.programDate), 'yyyy-MM-dd'));
          var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
          var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
          if((testingDate>=d1) && (testingDate<=d2)&& m.programTitle.indexOf(this.seachText)>-1)
          {
            return m;
          }
          
        })
      }

      if(this.selectedvehicleNo != undefined && this.selectedvehicleNo != "")
      {
      var datePipe = new DatePipe("en-US");
       
       filteredData = filteredData.filter(m =>{
         var testingDate = new Date(datePipe.transform(new Date(m.createdOn), 'yyyy-MM-dd'));
         var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
         var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
         if((testingDate>=d1) && (testingDate<=d2) && m.vehicleNo == this.selectedvehicleNo)
         {
           return m;
         }
         
       })
     }

      else
      {
        var datePipe = new DatePipe("en-US");
        
        filteredData = filteredData.filter(m =>{
          var testingDate = new Date(datePipe.transform(new Date(m.programDate), 'yyyy-MM-dd'));
          var d1 = new Date(datePipe.transform(new Date(this.fromDate), 'yyyy-MM-dd'));
          var d2 = new Date(datePipe.transform(new Date(this.endDate), 'yyyy-MM-dd')); 
          if((testingDate>=d1) && (testingDate<=d2))
          {
            return m;
          }
          
        })
      }
      }
      else
      {
        if((this.fromDate==undefined || this.fromDate=="") && (this.endDate==undefined|| this.endDate=="") && (this.seachText==undefined||this.seachText=="") && (this.selectedvehicleNo==undefined||this.selectedvehicleNo==""))
        {
          this.toastr.error('Please provide search value');
        }

        else if ((this.selectedvehicleNo != undefined && this.selectedvehicleNo != ""))
        {
          if((this.fromDate==undefined||this.fromDate=="")&&(this.endDate!=undefined &&this.endDate!="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
          if((this.fromDate!=undefined&&this.fromDate!="")&&(this.endDate==undefined||this.endDate=="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
        }

        else if ((this.seachText != undefined && this.seachText != ""))
        {
          if((this.fromDate==undefined||this.fromDate=="")&&(this.endDate!=undefined &&this.endDate!="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
          if((this.fromDate!=undefined&&this.fromDate!="")&&(this.endDate==undefined||this.endDate=="")) 
          {
            this.toastr.error('Please provide both from Date and end Date');
          }
          
        }
        else
        {

          this.toastr.error('Please provide both from Date and end Date');
        }
      
      }
      this.AwpsRecordData = filteredData; 
     return this.AwpsRecordData;  
    }

    reset() {
      debugger
      // window.location.reload();
      this.selectedvehicleNo=""
      this.seachText="";
      this.fromDate="";
      this.endDate="";
      this.ngOnInit();
    }

    back(): void {
      this.location.back()
    }

    exportexcel(): void {

      this.p1=1;

      /* pass here the table id */
      let element = document.getElementById('componentID');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, this.fileName);
  
    }

    backDeleteStateWiseAwarenessData(){
      this.isReadMode = true;
      this.isDeleteMode = false;
      }

      excelLength(event:any){
        console.log(event)
        this.selectCount=event;
      }

      pageChange(event:any){
        console.log(event);
        this.p=event;
      }

}
